import classNames from "classnames";
import React, { useImperativeHandle, useRef } from "react";

import { BottomMenuPanel } from "../../bottom-menu-panel";
import { BottomMenuButtons, IBottomMenuButtonsRef } from "../../bottom-menu/buttons";
import { TransparentButton } from "../../transparent-button";

import "./color-bottom-menu-panel.css";

export type IColorBottomMenuPanelRef = IBottomMenuButtonsRef;

/** One button of the TextColorPanel */
const ColorBottomMenuPanelItem = ({
	color,
	isActive,
	onClick,
}: {
	color: eXpress.core.IColor;
	isActive?: boolean;
	onClick(): void;
}) => (
	<TransparentButton // Used transparent button to have button behavior: focusable, cursor
		className={`color-bottom-menu-panel__item ${
			isActive ? "color-bottom-menu-panel__item--active" : ""
		}`}
		onClick={onClick}
	>
		<div
			className="color-bottom-menu-panel__item-color"
			style={{
				backgroundColor: color.hexColorString,
			}}
		>
			{color.colorStyle === "fluo" && (
				<span className="color-bottom-menu-panel__item-color--fluo">FLUO</span>
			)}
			{color.colorStyle === "gold" && (
				<span className="color-bottom-menu-panel__item-color--gold">GOLD</span>
			)}
		</div>
	</TransparentButton>
);
ColorBottomMenuPanelItem.displayName = "ColorBottomMenuPanelItem";

interface IColorBottomMenuPanelProps {
	colors: readonly eXpress.core.IColor[];
	selectedColor: eXpress.HexColorString | undefined;
	onClick?(color: eXpress.core.IColor): void;
	className?: string;
	ref?: React.Ref<IColorBottomMenuPanelRef>;
}

/** Panel with a list of supported colors */
export function ColorBottomMenuPanel({
	colors,
	selectedColor,
	onClick,
	className,
	ref: parentRef,
}: IColorBottomMenuPanelProps) {
	const bottomMenuRef = useRef<IBottomMenuButtonsRef>(null);

	useImperativeHandle(parentRef, () => bottomMenuRef.current as IColorBottomMenuPanelRef, []);

	return (
		<BottomMenuPanel className={classNames("color-panel", className)}>
			<BottomMenuButtons ref={bottomMenuRef}>
				{colors.map((color) => (
					<ColorBottomMenuPanelItem
						key={color.hexColorString}
						color={color}
						isActive={selectedColor === color.hexColorString}
						onClick={() => onClick?.(color)}
					/>
				))}
			</BottomMenuButtons>
		</BottomMenuPanel>
	);
}
